function loadView(view) {
	return () =>
		import(/* webpackChunkName: "view-[request]" */ `@/components/${view}.vue`)
}

import TournamentsRoutes from './back/tournaments'
import TeamsRoutes from './back/teams'
import UsersRoutes from './back/users'
import ShopRoutes from './back/shop'
import BetsRoutes from './back/bets'

const routes = [
	{
		path: '',
		name: 'Dashboard',
		component: loadView('Auth/Home'),
	},
	{
		path: 'edit-my-info',
		name: 'EditUser',
		component: loadView('Auth/Edit'),
	},
	{
		path: 'change-my-paswword',
		name: 'ChangePassword',
		component: loadView('Auth/ChangePassword'),
	},
	// SuperAdmin
	{
		path: 'slider-primary',
		name: 'Slider',
		component: loadView('Admin/Slider/List'),
	},
	{
		path: 'slider-primary/create',
		name: 'SliderAdd',
		component: loadView('Admin/Slider/EditCreate'),
	},
	{
		path: 'slider-primary/:sliderId/edit',
		name: 'SliderEdit',
		component: loadView('Admin/Slider/EditCreate'),
	},
	{
		path: 'slider-primary/:sliderId/delete',
		name: 'SliderDelete',
		component: loadView('Admin/Slider/Delete'),
	},
	{
		path: 'administrators',
		name: 'Administrator',
		component: loadView('Admin/Administrators/List'),
	},
	{
		path: 'administrators/editar-usuario',
		name: 'EditUserInfoAdmin',
		component: loadView('Admin/Administrators/EditUser'),
	},
	{
		path: 'administrators/clear-images',
		name: 'ClearImages',
		component: loadView('Admin/ClearImages'),
	},
	// Cambiar contraseña solo para el super
	{
		path: 'super/change-password',
		name: 'SuperChangePassword',
		component: loadView('Admin/ChangePassword'),
	},
	// Cambiar el nick de otro usuario
	{
		path: 'super/change-nick',
		name: 'SuperChangeNick',
		component: loadView('Admin/ChangeNick'),
	},
	// Cambiar a premium a un usuario
	{
		path: 'super/change-to-premium',
		name: 'SuperChangeToPremium',
		component: loadView('Admin/ChangeToPremium'),
	},
	// Ruta para editar la información de otro usuario
	{
		path: 'super/update-information',
		name: 'SuperUpdateData',
		component: loadView('Admin/UpdateData'),
	},
	// Tutoriales
	{
		path: 'super/tutorials',
		name: 'SuperTutorials',
		component: loadView('Admin/Tutorial/List'),
	},
	// Ruta para las noticias - Usuarios
	{
		path: 'notices/list',
		name: 'NoticeUserList',
		component: loadView('Back/User/Notice/List'),
	},
	{
		path: 'notices/create',
		name: 'NoticeUserAdd',
		component: loadView('Back/User/Notice/CreateEdit'),
	},
	{
		path: 'notices/edit/:noticeId',
		name: 'NoticeUserEdit',
		component: loadView('Back/User/Notice/CreateEdit'),
	},
	{
		path: 'notices/delete/:noticeId',
		name: 'NoticeUserDelete',
		component: loadView('Back/User/Notice/Delete'),
	},
	{
		path: 'countries',
		name: 'AdminCountries',
		component: loadView('Admin/Country/List'),
	},
]

TournamentsRoutes.map((route) => {
	routes.push(route)
})

TeamsRoutes.map((route) => {
	routes.push(route)
})

UsersRoutes.map((route) => {
	routes.push(route)
})

ShopRoutes.map((route) => {
	routes.push(route)
})

BetsRoutes.map((route) => {
	routes.push(route)
})

export default routes
